import en from './en'
import es from './es'
import esEs from './es-es'
import ptBr from './pt-br'
import ptPt from './pt-pt'
import fr from './fr'
import de from './de'
import ar from './ar'
import it from './it'
import ru from './ru'
import ja from './ja'
import hi from './hi'
import id from './id'
import th from './th'
import tw from './tw'
import pl from './pl'

export default {
  en,
  es,
  'es-es': esEs,
  'pt-br': ptBr,
  'pt-pt': ptPt,
  fr,
  de,
  ar,
  it,
  ru,
  ja,
  hi,
  id,
  th,
  tw,
  pl,
}
